import { Component, inject, signal } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ReferralService } from '@core/services/referral.service';
import { CustomInputComponent } from '@shared/custom-input/custom-input.component';
import { SaveButtonComponent } from '@shared/save-button/save-button.component';
import { TurnstileComponent } from '@shared/turnstile/turnstile.component';
import { tap } from 'rxjs/operators';
import { MustMatch } from '../../services/custom-form-validators';
import { UserService } from '../../services/user.service';

@Component({
    selector: 'app-user-register',
    templateUrl: './user-register.component.html',
    styleUrls: ['./user-register.component.css'],
    imports: [
        ReactiveFormsModule,
        CustomInputComponent,
        SaveButtonComponent,
        TurnstileComponent,
    ],
})
export class UserRegisterComponent {
    private formBuilder = inject(FormBuilder);
    private router = inject(Router);
    private userService = inject(UserService);
    private referralService = inject(ReferralService);

    isSubmittingForm = signal(false);
    registrationErrorMessage = signal('');

    registerForm = this.formBuilder.nonNullable.group(
        {
            firstName: [
                '',
                [
                    Validators.required,
                    Validators.minLength(2),
                    Validators.maxLength(30),
                ],
            ],
            lastName: [
                '',
                [
                    Validators.required,
                    Validators.minLength(2),
                    Validators.maxLength(150),
                ],
            ],
            email: [
                '',
                [Validators.required, Validators.email],
                [this.userService.validateEmailExists.bind(this.userService)],
            ],
            password: ['', [Validators.required, Validators.minLength(8)]],
            confirmPassword: ['', [Validators.required]],
            captchaToken: ['', [Validators.required]],
        },
        {
            validators: [MustMatch('password', 'confirmPassword')],
        }
    );

    onSubmit() {
        this.registerForm.markAllAsTouched();
        if (this.registerForm.invalid) {
            return;
        }

        this.isSubmittingForm.set(true);
        this.registrationErrorMessage.set('');

        const registerFormValue = this.registerForm.getRawValue();

        this.userService
            .register({
                first_name: registerFormValue.firstName,
                last_name: registerFormValue.lastName,
                email: registerFormValue.email,
                phone_number: '',
                password1: registerFormValue.password,
                password2: registerFormValue.confirmPassword,
                referred_by: this.referralService.getReferralCode(),
                captcha_token: registerFormValue.captchaToken,
            })
            .pipe(
                tap({
                    next: () => {
                        this.isSubmittingForm.set(false);
                        this.router.navigate(['/dashboard']);
                    },
                    error: () => {
                        this.isSubmittingForm.set(false);
                        this.registrationErrorMessage.set(
                            'Failed to create account. Please try again.'
                        );
                    },
                })
            )
            .subscribe();
    }
}
